import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Layout from './components/Layout';

// Hovedsider
import Home from './pages/Home';
import About from './pages/About';
import Dictionary from './pages/Dictionary';
import NotFound from './pages/NotFound';

// Klynge A — Kørekort og vægt
import TrailerRegler from './pages/clusterA/TrailerRegler';
import KoerekortOgTrailer from './pages/clusterA/KoerekortOgTrailer';
import HvorMegetMaaManTraekke from './pages/clusterA/HvorMegetMaaManTraekke';
import TrailerTotalvaegt from './pages/clusterA/TrailerTotalvaegt';
import BeKoerekort from './pages/clusterA/BeKoerekort';
import Kugletryk from './pages/clusterA/Kugletryk';
import TrailerBremser from './pages/clusterA/TrailerBremser';
import TrailerLaengdeOgBredde from './pages/clusterA/TrailerLaengdeOgBredde';

// Klynge B — Hastighed og kørsel
import TrailerHastighed from './pages/clusterB/TrailerHastighed';
import Tempo100 from './pages/clusterB/Tempo100';
import TrailerITyskland from './pages/clusterB/TrailerITyskland';
import TrailerISverige from './pages/clusterB/TrailerISverige';
import TrailerIUdlandet from './pages/clusterB/TrailerIUdlandet';
import Lastsikring from './pages/clusterB/Lastsikring';

// Klynge C — Syn, nummerplade, lys, forsikring, dæk
import TrailerSyn from './pages/clusterC/TrailerSyn';
import TrailerNummerplade from './pages/clusterC/TrailerNummerplade';
import TrailerLysRegler from './pages/clusterC/TrailerLysRegler';
import TrailerForsikring from './pages/clusterC/TrailerForsikring';
import TrailerVaegtafgift from './pages/clusterC/TrailerVaegtafgift';
import TrailerDaek from './pages/clusterC/TrailerDaek';
import LilleTrailer from './pages/clusterC/LilleTrailer';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <Routes>
          {/* Forside og statiske informationssider */}
          <Route path="/" element={<Home />} />
          <Route path="/om" element={<About />} />
          <Route path="/ordbog" element={<Dictionary />} />

          {/* Klynge A — Kørekort og vægt */}
          <Route path="/trailer-regler" element={<TrailerRegler />} />
          <Route path="/koerekort-og-trailer" element={<KoerekortOgTrailer />} />
          <Route path="/hvor-meget-maa-man-traekke" element={<HvorMegetMaaManTraekke />} />
          <Route path="/trailer-totalvaegt" element={<TrailerTotalvaegt />} />
          <Route path="/be-koerekort" element={<BeKoerekort />} />
          <Route path="/kugletryk" element={<Kugletryk />} />
          <Route path="/trailer-bremser" element={<TrailerBremser />} />
          <Route path="/trailer-laengde-og-bredde" element={<TrailerLaengdeOgBredde />} />

          {/* Klynge B — Hastighed og kørsel */}
          <Route path="/trailer-hastighed" element={<TrailerHastighed />} />
          <Route path="/tempo-100" element={<Tempo100 />} />
          <Route path="/trailer-i-tyskland" element={<TrailerITyskland />} />
          <Route path="/trailer-i-sverige" element={<TrailerISverige />} />
          <Route path="/trailer-i-udlandet" element={<TrailerIUdlandet />} />
          <Route path="/lastsikring" element={<Lastsikring />} />

          {/* Klynge C — Syn, nummerplade, lys, forsikring, dæk */}
          <Route path="/trailer-syn" element={<TrailerSyn />} />
          <Route path="/trailer-nummerplade" element={<TrailerNummerplade />} />
          <Route path="/trailer-lys-regler" element={<TrailerLysRegler />} />
          <Route path="/trailer-forsikring" element={<TrailerForsikring />} />
          <Route path="/trailer-vaegtafgift" element={<TrailerVaegtafgift />} />
          <Route path="/trailer-daek" element={<TrailerDaek />} />
          <Route path="/lille-trailer" element={<LilleTrailer />} />

          {/* 404 side */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </>
  );
}
